import * as React from 'react';

import {Button} from '../../../button/button';
import {SaveButton} from '../../../button/save-button/save-button';

import {getPeopleText} from '../../helpers';

import styles from './footer-add-buttons.module.css';

type Props = {
    companyName: string;
    onAddCompany: (buttonRef?: any) => any | null | undefined;
    onAddPeople: () => Promise<any> | null | undefined;
    numSelectedPeople: number;
    unlocksRemaining: number | null | undefined;
};

export function FooterAddButtons(props: Props) {
    const {onAddCompany, onAddPeople} = props;

    const [isSaving, setIsSaving] = React.useState<boolean>(false);

    const addCompanyButtonRef = React.useRef(null);

    const peopleText = getPeopleText(props.numSelectedPeople);

    let addButton;
    if (onAddCompany) {
        addButton = (
            <Button
                variant='save'
                size='big'
                getButtonRef={addCompanyButtonRef}
                isFullWidth={true}
                onClick={() => {
                    onAddCompany(addCompanyButtonRef.current);
                }}
            >
                Add <strong>{props.companyName}</strong>
                {peopleText ? ` & ${peopleText}` : ''}
            </Button>
        );
    } else if (onAddPeople && peopleText) {
        addButton = (
            <div>
                <SaveButton
                    // @ts-expect-error
                    onClick={() => {
                        setIsSaving(true);
                        // @ts-expect-error
                        onAddPeople()
                            .then(() => {
                                setIsSaving(false);
                            })
                            .catch(() => {
                                setIsSaving(false);
                            });
                    }}
                    buttonText={`Add ${peopleText}`}
                    savingText={`Adding ${peopleText}…`}
                    successText={`Added ${peopleText}`}
                    isSaving={isSaving}
                    resetOnComplete={true}
                    isFullWidth={true}
                    justifyCenter={true}
                    disabled={
                        typeof props.unlocksRemaining === 'number' &&
                        props.unlocksRemaining < props.numSelectedPeople
                    }
                />
                <div className={styles['credits-info']}>
                    Uses {props.numSelectedPeople}{' '}
                    {props.numSelectedPeople === 1 ? 'credit' : 'credits'}
                </div>
            </div>
        );
    }

    return addButton ? <div className={styles['footer-add-buttons']}>{addButton}</div> : null;
}
